import { IonContent, IonPopover } from '@ionic/react';
import { FC, ReactNode } from 'react';
import { isTablet } from "../../../../../common/utils";

export interface PopoverInfoProductionProps {
  render?: () => ReactNode;
  triggerId: string;
}

export const PopoverInfoProduction: FC<PopoverInfoProductionProps> = ({ render, triggerId }) => {
  return (
    <IonPopover
      trigger={triggerId}
      arrow
      triggerAction={isTablet ? 'click' : 'hover'}
      showBackdrop={false}
      size="auto"
      mode="ios"
    >
      <IonContent className="ion-padding">
        {render && render()}
      </IonContent>
    </IonPopover>
  );
};
